import { setAuthCookies } from "utils/cookieService";
import { startDashboardOnboardingLoginSession } from "utils/dashboardOnboardingSession";

// The identity block returned by the login endpoints
// (Account/login, Account/login/ValidateOTP). Offline access verify returns
// the same block when the attendee's email maps to a real account.
export interface AuthSessionData {
  token: string;
  email: string;
  fullName?: string;
  phone?: string | null;
  expiresIn?: string;
  roles?: string;
  country?: string;
}

/**
 * Persists an authenticated session (cookies + localStorage) exactly the way
 * the login flow does — but WITHOUT any navigation or onboarding redirect.
 *
 * Use this when a session should be established as a side effect of another
 * flow (e.g. unlocking offline access with the same OTP used for login), where
 * the caller controls where the user goes next.
 *
 * Returns false (and does nothing) when the payload carries no token to
 * persist, so callers can safely pass a response that may or may not include
 * auth fields.
 */
export function persistAuthSession(
  data: Partial<AuthSessionData> | null | undefined,
): boolean {
  if (!data?.token || !data?.email) return false;

  // Store user data in cookies (for cross-subdomain auth)
  setAuthCookies(data);

  // Also store in localStorage for backward compatibility
  localStorage.setItem("email", data.email);
  localStorage.setItem("user", JSON.stringify(data));
  localStorage.setItem("token", data.token);

  startDashboardOnboardingLoginSession(data.email);

  return true;
}
